import NvChart from '../NvChart';

function traits(commandName) {
  return [
    {
      type: 'run-command',
      buttonLabel: 'Configure',
      commandName: commandName
    }
  ];
}

function componentDefinition(editor, options) {
  const {componentCommandName} = options;

  const {componentType, componentName} = options;
  return {
    extend: 'react-component',
    model: {
      defaults: {
        'custom-name': componentName,
        component: NvChart,
        attributes: {
          settings: '',
        },
        traits: traits(componentCommandName),
      },
    },
    isComponent: el => el.tagName === componentType.toUpperCase()
  }
}

export default function (editor, options = {}) {
  editor.Components.addType(options.componentType, componentDefinition(editor, options));
}
